import React, { useState, Fragment } from "react";

import {
  addChargeEntry,
  changeAppointmentStatus,
  isAuthenticated,
} from "apiHandler/actions";
import {
  displayDateFormatter,
  open_billing_charge_entry,
  StatusCircle,
} from "components/helpers";
import placeholderLogo from "assets/placeholder.png";
import phoneIcon from "assets/phone.png";
import keyIcon from "assets/key.png";
import SuccessModal from "components/modals/successModal";
import AddAppointment from "components/modals/AddAppointment";
import ConfirmModal from "components/modals/Confirm";
import useSnackbar from "components/customHooks/useSnackbar";
import { useUserData } from "components/customHooks/userDataContext";
import { Modal, TextField } from "@mui/material";
import { getFormattedDate } from "utils/helper";

const AppointmentModal = (props) => {
  // props has id key from calendar //
  const [time, setTime] = useState(null);
  const [reason, setReason] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [reject, setReject] = useState(false);
  const [appDate] = useState(false);
  const [success, setSuccess] = useState(false);
  const [showUpdateAppntModal, setShowUpdateAppntModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const { CustomSnackbar, setSnackbarMessage } = useSnackbar();
  const userData = useUserData();
  const token = userData?.access_token;

  const onCheckIn = async () => {
    const { practice_id, patient_id, dos, id } = props;
    const payload = {
      practice_id,
      patient_id,
      service_date: displayDateFormatter(dos),
      encounter_details_id: id,
    };
    const response = await addChargeEntry(
      payload,
      userData?.billing_access_token,
    );
    if (response) {
      setSnackbarMessage(
        response?.charge_entry_id
          ? `Successfully created Charge Entry: ${response.charge_entry_id}`
          : "Successfully created Charge Entry.",
      );
      open_billing_charge_entry({
        patient_id: response.patient_id,
        charge_entry_id: response.charge_entry_id,
      });
    } else {
      setSnackbarMessage("Failed to create Charge Entry");
    }
    setShowConfirmModal(false);
  };

  const submitAppointment = async (status) => {
    if (!reason && !time) return;

    let payload = {
      appntId: props.appntId,
      appntStatus: status,
      uuid: isAuthenticated().uuid,
    };
    if (status !== "confirmed") payload["cancellationReason"] = reason;
    if (status === "confirmed") {
      let newDate = new Date(appDate);
      const year = newDate.getFullYear();
      let month = newDate.getMonth() + 1;
      let dates = newDate.getDate();
      month = month < 10 ? `0${month}` : month;
      dates = dates < 10 ? `0${dates}` : dates;
      payload["confirmedDateTime"] = `${year}-${month}-${dates}T${time}:00`;
    }
    const response = await changeAppointmentStatus(payload, token);
    if (response !== "ERROR") setSuccess(true);
    else alert("SOMETHING WENT WRONG");
  };
  if (success) return <SuccessModal onClose={props.onClose} />;
  return (
    <Modal onClose={props.onClose} open={true}>
      <div className="appnt-modal">
        <div className="appnt-pat-details">
          <img
            src={placeholderLogo}
            width={80}
            height={80}
            className="appnt-pd-icon"
            alt=""
          />
          <div className="appnt-pd-name-cont">
            <span className="appnt-pd-name">
              {props.registeredUser && (
                <img
                  src={keyIcon}
                  width={20}
                  height={12}
                  className="appnt-pd-key-icon"
                  alt=""
                />
              )}
              {props.patient_name} ({props.appntId})
            </span>
            {props.mobile && (
              <Fragment>
                <img
                  src={phoneIcon}
                  width={15}
                  height={18}
                  className="appnt-pd-phone-icon"
                  alt=""
                />
                {props.mobile}
              </Fragment>
            )}
          </div>
        </div>
        {/* <div className="appnt-insurance">INSURANCE</div> */}
        <hr />
        <div className="appnt-dr-details">
          <img
            src={placeholderLogo}
            width={40}
            height={40}
            className="appnt-pd-icon"
            alt=""
          />
          <div className="flex-1">
            <span className="appnt-dr-name">Dr {props.provider_name}</span>
            {props.providerSpecialties && props.providerSpecialties[0] && (
              <span className="appnt-dr-special">
                {props.providerSpecialties[0]?.specialtyName}
              </span>
            )}
          </div>
        </div>
        {props.offlineDuration && (
          <div>
            <span className="appnt-content-title">TIME SLOT </span>
            <span className="appnt-content-value">{props.offlineDuration}</span>
          </div>
        )}
        <div>
          <span className="appnt-content-title">Appointment Type </span>
          <span className="appnt-content-value">{props.appt_type}</span>
        </div>
        <div>
          <span className="appnt-content-title">Encounter ID </span>
          <span className="appnt-content-value">
            {props.practice_encounter_id || "N/a"}
          </span>
        </div>
        <div>
          <span className="appnt-content-title">Patient ID </span>
          <span className="appnt-content-value">
            {props.practice_patient_id || "N/A"}
          </span>
        </div>
        <div>
          <span className="appnt-content-title">Confirm Status </span>
          <span className="appnt-content-value">
            {props.confirm_status || "N/A"}
          </span>
        </div>
        <div>
          <span className="appnt-content-title">Reminder Status </span>
          <span className="appnt-content-value">
            {props.reminder_status || "N/A"}
          </span>
        </div>
        <div>
          <span className="appnt-content-title">Chief Complaint </span>
          <span className="appnt-content-value">
            {props.chief_complaint || "N/A"}
          </span>
        </div>
        <div>
          <span className="appnt-content-title">DATE AND TIME</span>
          <span className="appnt-content-value">
            {getFormattedDate(props.dos)} {props.dos_time}
          </span>
        </div>
        {/* <div className="appnt-content-title">DATE AND TIME</div> */}
        {/* {props.appntStatus === "waiting" &&
          props.appointmentPreferences &&
          props.appointmentPreferences.map((app) => (
            <div key={app.appntPrefId}>
              {(props.id && props.id !== app.appntPrefId) || (
                <FormControlLabel
                  control={
                    <Radio
                      checked={app.appntPrefId === selectedId}
                      onChange={() => {
                        setSelectedId(app.appntPrefId);
                        setAppDate(app.appntDate);
                      }}
                    />
                  }
                  label={`
                                        ${displayDateFormatter(props.dos)}  ${
                    props.dos_time
                  }
                                    `}
                />
              )}
            </div>
          ))} */}
        {/* {(props.appntStatus === "confirmed" ||
          props.appntStatus === "cancellationrequest") && (
          <div className="appnt-confirm-time">
            <span className="appnt-confirm-date">
              {displayDateFormatter(props.appntDate.slice(0, 10))}
            </span>
            {displayTimeFormatter(props.appntDate.slice(11, 19))} (
            {props.timeZone})
          </div>
        )} */}
        <div className="appnt-status-type">
          <StatusCircle
            status={props.appntStatus}
            offlineType={props.offlineType}
          />
          {props.appntStatus === "cancellationrequest"
            ? "cancellation request"
            : props.appntStatus}
        </div>
        {props.offlineType && (
          <div className="appnt-virtual">(OFFLINE CONSULTATION)</div>
        )}
        <hr />
        <div className="btn-cont">
          <button
            className="blank-hover-btn"
            onClick={() => setShowUpdateAppntModal(true)}
          >
            Edit
          </button>
          {displayDateFormatter(props.dos) ===
          displayDateFormatter(new Date()) ? (
            <button
              className="blank-hover-btn"
              onClick={() => setShowConfirmModal(true)}
            >
              Check In
            </button>
          ) : null}
          <button className="blank-hover-btn" onClick={() => props.onClose()}>
            Cancel
          </button>
        </div>
        {props.appntStatus === "waiting" && (
          <Fragment>
            <button
              className="appnt-submit-btn"
              onClick={() => {
                setConfirm(true);
                setReject(false);
              }}
            >
              CONFIRM
            </button>
            <button
              className="appnt-submit-btn"
              onClick={() => {
                setReject(true);
                setConfirm(false);
              }}
            >
              REJECT
            </button>
            {confirm && (
              <div className="appnt-send-div">
                <TextField
                  style={{ margin: "5px auto", width: "100%" }}
                  type="time"
                  onChange={(e) => setTime(e.target.value)}
                />
                <button
                  className="appnt-send-btn"
                  onClick={() => submitAppointment("confirmed")}
                >
                  SEND
                </button>
              </div>
            )}
            {reject && (
              <div className="appnt-send-div">
                <TextField
                  style={{ margin: "5px auto", width: "100%" }}
                  placeholder="Reason to cancel"
                  onChange={(e) => setReason(e.target.value)}
                />
                <button
                  className="appnt-send-btn"
                  onClick={() => submitAppointment("rejected")}
                >
                  SEND
                </button>
              </div>
            )}
          </Fragment>
        )}
        {props.appntStatus === "confirmed" && (
          <Fragment>
            <button
              className="appnt-submit-btn appnt-confirm-btn"
              // onClick={()=>{setConfirm(true);setReject(false);}}
              // open message Modal
              onClick={props.showChatModal}
            >
              Message
            </button>
            <button
              className="appnt-submit-btn appnt-confirm-btn"
              onClick={props.showRescheduleModal}
            >
              Reschedule
            </button>
            <button
              className="appnt-submit-btn appnt-confirm-btn"
              onClick={() => {
                setReject(true);
                setConfirm(false);
              }}
            >
              Cancel
            </button>
            {reject && (
              <div className="appnt-send-div">
                <TextField
                  style={{ margin: "5px auto", width: "100%" }}
                  placeholder="Reason to cancel"
                />
                <button
                  className="appnt-send-btn"
                  onClick={() => submitAppointment("rejected")}
                >
                  SEND
                </button>
              </div>
            )}
          </Fragment>
        )}
        {props.appntStatus === "cancellationrequest" && (
          <Fragment>
            <button
              className="appnt-submit-btn appnt-accept-btn"
              onClick={() => submitAppointment("cancelled")}
            >
              Accept
            </button>
          </Fragment>
        )}
        {showUpdateAppntModal && (
          <AddAppointment
            appointemnt_data={props.appointment}
            onClose={() => setShowUpdateAppntModal(false)}
          />
        )}
        {
          // completed
          // followup
          // no show
        }
        {showConfirmModal ? (
          <ConfirmModal
            onClose={() => setShowConfirmModal(false)}
            message={`Are you sure you need to Check In: ${props.first_name} ${props.last_name} ?`}
            onSubmit={() => onCheckIn()}
            confirmMain="Check In"
          />
        ) : null}
        <CustomSnackbar />
      </div>
    </Modal>
  );
};

export default AppointmentModal;
